import { Link } from "react-router-dom";

const One = () => {
  return (
    <>
      <div className="container-fluid jumbotron jumbotron-image py-5">
        <div className="container">
          <h1 className="display-3 fw-bold text-white">Simpozion #1</h1>
        </div>
      </div>
      <div className="container">
        <nav aria-label="breadcrumb" className="mb-3 mt-4 ms-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Acasă</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/evenimente">Evenimente</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Simpozion #1
            </li>
          </ol>
        </nav>
        <div className="container history">
          <div className="row">
            <div className="col-lg-12 bg-light rounded p-4">
              <h2 className=" pb-1 mb-4 fst-italic">Invitație</h2>
              <p>
                Catedra de Hematologie al UMF Iuliu Hatieganu Cluj- Napoca vă
                invită să participați la simpozionul intitulat “ Manifestări
                cutanate în bolile oncohematologice” ce sa va desfășura în
                Cluj-Napoca în data de 9 martie 2024 incepand cu ora 10, în Sala
                Multimedia de pe strada Victor Babes nr 8.
              </p>
              <p>
                Tema principală a acestui eveniment sunt limfoamele primar
                cutanate, scopul nostru fiind sublinierea importanței abordării
                multidisciplinare a acestei patologii, iar din acest motiv am
                invitat atât medici hematologi, cât și anatomopatologi,
                dermatologi și radioterapeuți. Pe parcursul simpozionului vor fi
                susținute prezentări teoretice, deasemenea vă vom prezenta o
                serie de cazuri clinice din experiența proprie.
              </p>
              <p>
                Dorim ca această manifestare științifică să fie una interactivă
                și să faciliteze în viitor colaborarea dintre specialiștii
                implicați în diagnosticarea și tratarea limfoamelor cutanate.
                Simpozionul se adresează atat medicilor specialiști (
                hematologi, dermatologi, oncologi, radioterapeuți) cat și
                medicilor rezidenti.
              </p>
              <p>
                Vă rugăm confirmați participarea dvs completând formularul de
                mai jos. Participarea este gratuită.
              </p>
              <p>Vă așteptăm cu drag!</p>
              <p className="mb-1">
                Formular înscriere:{" "}
                <a href="https://docs.google.com/forms/d/e/1FAIpQLScPJ8-0UnMuC5H9UdkIozBZkEfgLvTrkjRG3HSOm2hAaweQ1Q/viewform">
                  Link
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default One;
